module.exports = __webpack_public_path__ + "img/personOnlineConsultation.acbbd368.svg";